<template>
    <div id="program_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ProgramHeader" v-if="$route.params.id > 0">Update Program</span>
                    <span class="page-title" id="ProgramHeader" v-else>Add Program</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-type-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="programForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="customer_id">Base Program:</label>
                                        <v-select v-model="program_id" name="program_id" id="program_id" label="text" :filterable="false" :options="programArr" @search="onSearchProgram" placeholder="Select Program" class='custom-ci-auto-search close-remove'>
                                            <template slot="no-options">
                                                Search Program...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description" spellcheck="true">
                                        <!-- <div class="field-error">{{description_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Program Type:</label>
                                        <v-select class="section-id" v-model="program_type" name="program_type" placeholder="Select Program Type"
                                            label="text"
                                            :options="programTypeArr">
                                        </v-select>
                                        <!-- <div class="field-error">{{program_type_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Start Date:</label>
                                        <date-picker placeholder="MM/DD/YYYY" id="start_date" @dp-change="onStartChange" ref="start_date" name="start_date" v-model="start_date" :config="fromOptionsDate"></date-picker>
                                        <!-- <label for="start_date" class="fp-calendar input-calender-icon"></label> -->
                                        <div class="field-error">{{start_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">End Date:</label>
                                        <date-picker placeholder="MM/DD/YYYY" id="end_date" @dp-change="onEndChange"  ref="end_date" name="end_date" v-model="end_date" :config="toOptionsDate"></date-picker>
                                        <!-- <label for="end_date" class="fp-calendar input-calender-icon"></label> -->
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Category:</label>
                                        <v-select class="section-id" v-model="category" name="category" placeholder="Select Category"
                                            label="text"
                                            :options="programCategoryArr">
                                        </v-select>
                                        <!-- <div class="field-error">{{category_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Est. Hours:</label>
                                        <input type="text" class="form-control" v-model="hours" id="hours" placeholder="Enter Hours" name="hours">
                                        <!-- <div class="field-error">{{hours_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Priority:</label>
                                        <v-select class="section-id" v-model="priority" name="priority" placeholder="Select Priority"
                                            label="text"
                                            :options="priorityArr">
                                        </v-select>
                                        <!-- <div class="field-error">{{category_error_msg}}</div> -->
                                    </div>
                                </div>

                                <div v-if="rows && rows.length > 0" class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require">Interval Type</th>
                                                <!-- <th scope="col" class="require">Absolute/Elapsed</th> -->
                                                <th scope="col" :class="requireFrom">From Value</th>
                                                <th scope="col" :class="requireTo">To Value</th>
                                                <th scope="col" :class="requireUOM" class='w-25'>UOM</th>
                                                <th scope="col">Metric</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(read, index) in rows" :key="index">
                                                <td>
                                                    <v-select class="section-id" id ="interval_type" v-model="read.interval_type" name="interval_type" placeholder="Select Interval"
                                                        label="text" @input="onIntervalSelect($event)"
                                                        :options="intervalTypeArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.interval_type_error_msg }}</div>
                                                </td>
                                                <!-- <td>
                                                    <v-select class="section-id" v-model="read.absolute_elapsed" name="absolute_elapsed" placeholder="Select Absolute Elapsed"
                                                        label="text"
                                                        :options="absoluteElapsedArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.absolute_elapsed_error_msg }}</div>
                                                </td> -->
                                                <td>
                                                    <input type="text" class="form-control" v-model="read.from_value" id="from_value" @keypress="isNumber($event)" placeholder="Enter From Value" name="from_value">
                                                    <div class="field-error">{{ read.from_value_error }}</div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="read.to_value" id="to_value" @keypress="isNumber($event)" placeholder="Enter To Value" name="to_value">
                                                    <div class="field-error">{{ read.to_value_error }}</div>
                                                </td>
                                                <td>
                                                    <v-select class="section-id" v-model="read.uom_id" name="uom_id" @input="onChangeUOM($event,read.uom_id,index)" placeholder="Select UOM"
                                                        label="text"
                                                        :options="vomArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.uom_error }}</div>
                                                </td>
                                                <td>
                                                    <span>{{read.metric}}</span>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click.prevent="removeElement(index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Line Item
                                        </button>
                                    </div>
                                </div>
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="createProgramBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="createProgram">
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createProgramBtn" v-else class="btn btn-primary" v-on:click.prevent="createProgram" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueProgramBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="createProgram(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelProgramBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment';


export default {
  name: "ProgramCreate",
  
  mixins:[commonMixins,contractMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Program | " +process.env.COPYRIGHT_NAME : "Create Program | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    description: "",
    program_type:"",
    start_date:"",
    end_date: "",
    category: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: "",
    hours: "",
    priority:"",
    priorityArr:[],
    rows:[],
    vomArr:[],
    start_date_error_msg:'',
    absoluteElapsedArr:[{text:'Absolute',value:'absolute'},{text:'Elapsed',value:'elapsed'}],
    requireUOM:'',
    requireFrom:'',
    requireTo:'',
    programArr:[],
    program_id:'',
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_type') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        self.loadFieldData(['selectedmeasurementUnit','priority']);
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadPrograms();
        }else{
             self.rows.push({
                interval_id:0,
                interval_type: '',
                interval_type_error_msg:'',
                from_value: '',
                from_value_error:'',
                to_value_error:'',
                uom_error:'',
                to_value:'',
                uom_id:'',
                metric:'',
            });
        }
  },
  methods: {

    BackVehicleList() {
      var self = this;
      self.$router.push("/program/list");
    },


    checkSelected() {
        var self = this;
        if (self.is_default != true) {
            self.checkboxValue = 1;
        } else {
            self.checkboxValue = 0;
        }
    },
    // onSearchProgram(search, loading) {
    //     var self = this;
    //     if (search.length > 1) {

    //         loading(true);
    //         self.searchField(loading, search, 'program');
    //     }
    // },
    getSectionTypes(){

        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/contracttype/getsectionrate",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            data:{
                type:'variable'
            },
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.sectionTypes = data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR,true,'contract-asset-get-section-rate')
            }
        });
    },

    createProgram(flag) {
        var self = this;

        self.name = self.name.trim();
        var error = false;

        self.name_error_msg = "";
        self.start_date_error_msg = "";

        if (self.name == null || self.name == "") {
            self.name_error_msg = "Name required.";
            error = true;
        }
        if ( self.start_date == null || self.start_date == "") {
            self.start_date_error_msg = "Start Date required.";
            error = true;
        }
        var typeCheckArr = [];
        for (var i = 0; i < self.rows.length; i++) {
            self.rows[i].interval_type_error_msg = "";
            self.rows[i].from_value_error = "";
            self.rows[i].to_value_error = "";
            self.rows[i].uom_error = "";
            // self.rows[i].absolute_elapsed_error_msg = "";
            if (typeCheckArr.includes(self.rows[i].interval_type.value)){
                self.rows[i].interval_type_error_msg = "Cannot use same interval twice";
                error = true;
            }
            if (self.rows[i].interval_type == null || self.rows[i].interval_type == '' || !self.rows[i].interval_type) {
                self.rows[i].interval_type_error_msg = "Interval Type is Required.";
                error = true;
            }
            typeCheckArr.push(self.rows[i].interval_type.value);

            if (self.rows[i].interval_type != null && self.rows[i].interval_type != '' && self.rows[i].interval_type.value && self.rows[i].interval_type.value != 'o') {

                if (self.rows[i].from_value == null || self.rows[i].from_value == ''){
                    self.rows[i].from_value_error = "From Value is Required.";
                    error = true;
                }

                if (self.rows[i].to_value == null || self.rows[i].to_value == ''){
                    self.rows[i].to_value_error = "To Value is Required.";
                    error = true;
                }

            }
            if (self.rows[i].interval_type != null && self.rows[i].interval_type != '' && self.rows[i].interval_type.value && self.rows[i].interval_type.value == 'm') {

                if (self.rows[i].uom_id == null || self.rows[i].uom_id == ''){
                    self.rows[i].uom_error = "UOM Required.";
                    error = true;
                }
            }
            // if (self.rows[i].absolute_elapsed == null || self.rows[i].absolute_elapsed == '' || !self.rows[i].absolute_elapsed) {
            //     self.rows[i].absolute_elapsed_error_msg = "Please Select Absolute Or Elapsed.";
            //     error = true;
            // }

        }

      if (!error){

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createProgramBtn").val("Updating ...");
                $("#createProgramBtn").prop("disabled", true);
                $("#cancelProgramBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueProgramBtn").val("Saving ...");
                    $("#createProgramBtn").prop("disabled", true);
                    $("#createAndContinueProgramBtn").prop("disabled", true);
                    $("#cancelProgramBtn").prop("disabled",true);

                }else{

                    $("#createProgramBtn").val("Saving ...");
                    $("#createProgramBtn").prop("disabled", true);
                    $("#createAndContinueProgramBtn").prop("disabled", true);
                    $("#cancelProgramBtn").prop("disabled",true);
                }

            }

        var fields = $("#programForm").serializeArray();

            if (self.program_type != null && self.program_type.value){
                fields.push({
                    name: "program_type",
                    value: self.program_type.value
                });
            }else{
                fields.push({
                    name: "program_type",
                    value: ''
                });
            }
             if (self.program_id != null && self.program_id.value){
                fields.push({
                    name: "program_id",
                    value: self.program_id.value
                });
            }else{
                fields.push({
                    name: "program_id",
                    value: ''
                });
            }

            if (self.category != null && self.category.value){
                fields.push({
                    name: "category",
                    value: self.category.value
                });
            }else{
                fields.push({
                    name: "category",
                    value: ''
                });
            }

            if (self.priority != null && self.priority.value){
                fields.push({
                    name: "priority",
                    value: self.priority.value
                });
            }else{
                fields.push({
                    name: "priority",
                    value: ''
                });
            }

            fields.push({
                name: "items",
                value: JSON.stringify(self.rows)
            });

            if (segments[3]){
                fields.push({
                    name: "id",
                    value: segments[3]
                });
            }else{
                fields.push({
                    name: "id",
                    value: 0
                });
            }

            $.ajax({
                url: process.env.ROOT_API + "/program/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createProgramBtn").val("Update");
                        $("#createProgramBtn").prop("disabled", false);
                        $("#cancelProgramBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueProgramBtn").val("Save and Continue");
                            $("#createProgramBtn").prop("disabled", false);
                            $("#createAndContinueProgramBtn").prop("disabled", false);
                            $("#cancelProgramBtn").prop("disabled",false);

                        }else{

                            $("#createProgramBtn").val("Save");
                            $("#createProgramBtn").prop("disabled", false);
                            $("#createAndContinueProgramBtn").prop("disabled", false);
                            $("#cancelProgramBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.name = "";
                            self.description = 0;
                            self.program_type = "";
                            self.priority = "";
                            self.category = "";
                            self.start_date = "";
                            self.end_date = "";
                            self.hours = "";
                            self.rows = [];
                            self.rows.push({
                                interval_id:0,
                                interval_type: '',
                                interval_type_error_msg:'',
                                // absolute_elapsed:'',
                                // absolute_elapsed_error_msg:'',
                                from_value: '',
                                to_value:'',
                                from_value_error:'',
                                to_value_error:'',
                                uom_error:'',
                                uom_id:'',
                                metric:'',
                            });

                        }else{
                            if (data.content.id){
                                self.$router.push("/program-asset/list/"+data.content.id);
                            }else{
                                self.$router.push("/program/list");
                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                   self.loading = false;
                   if (segments[3])
                    {
                        $("#createProgramBtn").val("Update");
                        $("#createProgramBtn").prop("disabled", false);
                        $("#cancelProgramBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#ProgramForm").trigger("reset");

                            $("#createAndContinueProgramBtn").val("Save and Continue");
                            $("#createProgramBtn").prop("disabled", false);
                            $("#createAndContinueProgramBtn").prop("disabled", false);
                            $("#cancelProgramBtn").prop("disabled",false);

                        }else{

                            $("#createProgramBtn").val("Save");
                            $("#createProgramBtn").prop("disabled", false);
                            $("#createAndContinueProgramBtn").prop("disabled", false);
                            $("#cancelProgramBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-type-create')
                }
            });

      }else{
            self.errorValidationFocus();
      }

    },
    addRow: function () {

        var self = this;
        var i = self.rows.length - 1;
        var error = false;
        self.rows[i].interval_type_error_msg = "";
        self.rows[i].from_value_error = "";
        self.rows[i].to_value_error = "";
        self.rows[i].uom_error = "";

        if (self.rows[i].interval_type != null && self.rows[i].interval_type != '' && self.rows[i].interval_type.value &&  self.rows[i].interval_type.value == 'o') {
        // && self.rows[i].absolute_elapsed != null && self.rows[i].absolute_elapsed != '' && self.rows[i].absolute_elapsed.value ) {

                self.rows.push({
                    interval_id:0,
                    interval_type: '',
                    interval_type_error_msg:'',
                    // absolute_elapsed:'',
                    // absolute_elapsed_error_msg:'',
                    from_value: '',
                    to_value:'',
                    from_value_error:'',
                    to_value_error:'',
                    uom_error:'',
                    uom_id:'',
                    metric:'',
                });

        } else {
            if (self.rows[i].interval_type == null || self.rows[i].interval_type == '' || !self.rows[i].interval_type) {
                self.rows[i].interval_type_error_msg = "Interval Type is Required.";
                error = true;
            }

            if (self.rows[i].interval_type != null && self.rows[i].interval_type != '' && self.rows[i].interval_type.value && self.rows[i].interval_type.value != 'o') {

                if (self.rows[i].from_value == null || self.rows[i].from_value == ''){
                    self.rows[i].from_value_error = "From Value is Required.";
                    error = true;
                }

                if (self.rows[i].to_value == null || self.rows[i].to_value == ''){
                    self.rows[i].to_value_error = "To Value is Required.";
                    error = true;
                }

            }
            if (self.rows[i].interval_type != null && self.rows[i].interval_type != '' && self.rows[i].interval_type.value && self.rows[i].interval_type.value == 'm') {

                if (self.rows[i].uom_id == null || self.rows[i].uom_id == ''){
                    self.rows[i].uom_error = "UOM Required.";
                    error = true;
                }
            }

            // if (self.rows[i].absolute_elapsed == null || self.rows[i].absolute_elapsed == '' || !self.rows[i].absolute_elapsed) {
            //     self.rows[i].absolute_elapsed_error_msg = "Please Select Absolute Or Elapsed.";
            //     error = true;
            // }
            if (!error){
                self.rows.push({
                    interval_id:0,
                    interval_type: '',
                    interval_type_error_msg:'',
                    // absolute_elapsed:'',
                    // absolute_elapsed_error_msg:'',
                    from_value: '',
                    to_value:'',
                    from_value_error:'',
                    to_value_error:'',
                    uom_error:'',
                    uom_id:'',
                    metric:'',
                });
            }
        }
    },
    removeElement: function (index) {
        var self = this;

        if (self.rows.length > 1) {
                if (self.rows[index].interval_id == 0) {
                    self.rows.splice(index, 1);

                } else {
                    if (confirm('Are you sure that you want to delete this Interval? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/program-interval/delete",
                            type: "POST",
                            data: {
                                'id': self.rows[index].interval_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.rows.splice(index, 1);
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-delete-item')
                            },
                        });
                    }
                }
            }
    },

    loadPrograms() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/program/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                console.log(data);
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.description = data.content.description;
                    self.hours = data.content.hours;
                    // self.program_type = data.content.type;
                    self.start_date = data.content.program_start_date;
                    self.end_date = data.content.program_end_date;

                    // set min and max date for start and end date as some time its not called...
                    if ( self.end_date != "" && self.end_date != null ) {
                        self.$set(self.fromOptionsDate, 'maxDate', moment(self.end_date,"MM/DD/YYYY"));
                    }
                    self.$set(self.toOptionsDate, 'minDate', moment(self.start_date,"MM/DD/YYYY"));


                    // self.category = data.content.category;
                    for(var l =0;l < self.priorityArr.length;l++){
                        if (self.priorityArr[l].value == data.content.priority){
                            self.priority = {text:self.priorityArr[l].text,value:data.content.priority};
                        }
                    }
                    for(var k =0;k < self.programTypeArr.length;k++){
                        if (self.programTypeArr[k].value == data.content.type){
                            self.program_type = {text:self.programTypeArr[k].text,value:data.content.type};
                        }
                    }
                    for(var j =0;j < self.programCategoryArr.length;j++){
                        if (self.programCategoryArr[j].value == data.content.category){
                            self.category = {text:self.programCategoryArr[j].text,value:data.content.category};
                        }
                    }
                    // if (data.content.parent_id != undefined && data.content.parent_id != null){
                    //     self.program_id = {text:data.content.parent_name,value:data.content.parent_id};
                    // }
                    var arrData = data.content.row;
                    if (arrData){
                        for (var i = 0; i < arrData.length; i++){
                            var intervalType = '';
                            for(var l =0;l < self.intervalTypeArr.length;l++){
                                if (self.intervalTypeArr[l].value == arrData[i].interval_type){

                                    intervalType = {text:self.intervalTypeArr[l].text,value:arrData[i].interval_type};

                                }
                            }
                            self.rows.push({
                                interval_id:arrData[i].interval_id,
                                interval_type:intervalType,
                                interval_type_error_msg:'',
                                // absolute_elapsed:{text:self.titleCase(arrData[i].absolute_elapsed),value:arrData[i].absolute_elapsed},
                                // absolute_elapsed_error_msg:'',
                                from_value: arrData[i].from_value,
                                to_value:arrData[i].to_value,
                                uom_id:(arrData[i].uom_id != '')?arrData[i].uom:'',
                                from_value_error:'',
                                to_value_error:'',
                                uom_error:'',
                                metric:'',
                            })

                            self.onChangeUOM('',arrData[i].uom,i);
                        }
                    }else{
                        self.rows.push({
                            interval_id:0,
                            interval_type: '',
                            interval_type_error_msg:'',
                            // absolute_elapsed:'',
                            // absolute_elapsed_error_msg:'',
                            from_value: '',
                            to_value:'',
                            from_value_error:'',
                            to_value_error:'',
                            uom_error:'',
                            uom_id:'',
                            metric:'',
                        });
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-type-load-by-id')
            }
        });
    },
    onChangeUOM:function(evt,uom,index){
        var self = this;
console.log(uom);
        if (uom.symbol && uom.symbol == 'MLS'){
            self.rows[index].metric = 'DIST';
        }
        if (uom.symbol && uom.symbol == 'HRS'){
            self.rows[index].metric = 'HOUR';
        }
    },
    titleCase(str) {
      if ( str == null ) {
        return "-";
      } else {
        var value = str.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    onIntervalSelect(event) {
      var self = this;
      for (var i = 0; i < self.rows.length; i++) {
        //console.log(self.rows[i].interval_type.value); return;
          if (self.rows[i].interval_type != null) {
                if (self.rows[i].interval_type.value == "d" || self.rows[i].interval_type.value == "n") {
                    self.requireFrom = 'require';
                    this.requireTo = 'require';
                    this.requireUOM = '';
                } else if (self.rows[i].interval_type.value == "m") {
                    this.requireFrom = 'require';
                    this.requireTo = 'require';
                    this.requireUOM = 'require';
                } else if (self.rows[i].interval_type.value == "o") {
                      this.requireFrom = '';
                      this.requireTo = '';
                      this.requireUOM = '';
                }
          }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProgramCreate.vue